module.exports = __webpack_public_path__ + "img/4.f66a1246.png";